// extracted by mini-css-extract-plugin
module.exports = {"drawer":"drawer_drawer__2fOIE","inner":"drawer_inner__mMHFw"};